import {WidgetType} from './types';

export class UpdateWidgetsEvent {

}

export class UpdateSelectedWidgets {
	constructor(public studentLevel: WidgetType[], public classLevel: WidgetType[]) {
	}
}